import { useEffect } from "react";
import { isMobile } from "react-device-detect";

const useVideoSizes = (
  videoRefBg: React.RefObject<HTMLVideoElement>,
  setShowCurtain: React.Dispatch<React.SetStateAction<boolean>>,
  stateMachineState: any
) => {
  useEffect(() => {
    if (stateMachineState.matches("cameraLoading")) return;
    document.documentElement.style.setProperty(
      "--cardscan-video-width",
      videoRefBg?.current?.videoWidth
        ? `${videoRefBg?.current?.videoWidth.toString()}px`
        : "0"
    );
    document.documentElement.style.setProperty(
      "--cardscan-video-height",
      videoRefBg?.current?.videoHeight
        ? `${videoRefBg?.current?.videoHeight.toString()}px`
        : "0"
    );
    if (
      (videoRefBg?.current?.videoWidth &&
        videoRefBg?.current?.videoWidth > 2 * window.innerWidth) ||
      isMobile
    ) {
      setShowCurtain(true);
      const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty(
          "--cardscan-app-height",
          `${window.innerHeight}px`
        );
        doc.style.setProperty("--cardscan-app-width", `${window.innerWidth}px`);
      };
      window.addEventListener("resize", appHeight);
      appHeight();
      const videoFrame = document.getElementById("frame");
      videoFrame?.classList.add("heightFrame");
      const cameraButton = document.getElementById("camera-btn");
      cameraButton?.classList.add("heightFrame");
    }
  }, [
    videoRefBg?.current?.videoWidth,
    videoRefBg?.current?.videoHeight,
    setShowCurtain,
    videoRefBg,
    stateMachineState,
  ]);
};

export default useVideoSizes;
